export const config = {
  token_name: 'access_token',
  filters_name: 'settings.filters_001',
  cases_actions: 'settings.cases_actions',
};
